import React from 'react';

import { WorkflowRowBase } from '@/components/services/shared';

import type { DisplayWorkflow } from './types';

interface WorkflowToggleRowProps {
  /** Workflow data from API (source of truth) */
  workflow: DisplayWorkflow;
  disabled: boolean;
  serviceDisabled: boolean;
  onToggle: (enabled: boolean) => void;
  /** Async notes change handler - makes API call */
  onNotesChange: (notes: string) => Promise<void>;
}

/**
 * Workflow row component for matter services tab.
 *
 * Uses shared WorkflowRowBase for consistent UI/UX with firm services.
 * Matter-specific customization: placeholder text for case-specific context.
 */
export const WorkflowToggleRow: React.FC<WorkflowToggleRowProps> = ({
  workflow,
  disabled,
  serviceDisabled,
  onToggle,
  onNotesChange,
}) => (
  <WorkflowRowBase
    workflow={workflow}
    disabled={disabled}
    serviceDisabled={serviceDisabled}
    onToggle={onToggle}
    onNotesChange={onNotesChange}
    guidelineContext="case"
  />
);
